import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import DataTable from "examples/Tables/DataTable";
import useApi from "../../components/Utils/api";
import { useTranslation } from "react-i18next";

const recentMerchantColumns = [
  { Header: "MID", accessor: "mid", align: "left" },
  { Header: "Company", accessor: "companyName", align: "left" },
  { Header: "Owner", accessor: "ownerName", align: "left" },
  { Header: "Organization", accessor: (row) => row.referenceCompanyName ?? "—", align: "left" },
  {
    Header: "Status",
    accessor: (row) => (row.status === "1" ? "Active" : "Inactive"),
    align: "left",
  },
  {
    Header: "Created",
    accessor: (row) => (row.createdDt ? new Date(row.createdDt).toLocaleDateString() : "—"),
    align: "left",
  },
];

function SuperUserDashboard() {
  const { t } = useTranslation();
  const api = useApi();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api
      .get("dashboard/superuser")
      .then((res) => {
        setStats(res.data?.data ?? res.data ?? null);
      })
      .catch(() => {
        setStats(null);
      });
  }, []); // eslint-disable-line

  const cards = [
    { color: "dark", icon: "store", title: "Total Merchants", count: stats?.totalMerchantCount },
    { color: "success", icon: "storefront", title: "Active Merchants", count: stats?.activeMerchantCount },
    { color: "error", icon: "block", title: "Inactive Merchants", count: stats?.inactiveMerchantCount },
    { color: "info", icon: "trending_up", title: "Onboarded (30 days)", count: stats?.merchantsOnboardedLast30Days },
    { color: "primary", icon: "people", title: "Merchant Users", count: stats?.totalMerchantUserCount },
    { color: "secondary", icon: "admin_panel_settings", title: "Admin Users", count: stats?.adminUserCount },
    { color: "warning", icon: "apartment", title: "Organizations", count: stats?.organizationCount },
  ];

  return (
    <DashboardLayout>
      <MDBox py={3}>
        <Grid container spacing={3}>
          {cards.map((card) => (
            <Grid item xs={12} md={6} lg={3} key={card.title}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color={card.color}
                  icon={card.icon}
                  title={card.title}
                  count={card.count ?? "—"}
                  percentage={{ color: "success", amount: "", label: "" }}
                />
              </MDBox>
            </Grid>
          ))}
        </Grid>

        <MDBox mt={3}>
          <Card>
            <MDBox p={3} pb={1}>
              <MDTypography variant="h6" fontWeight="medium">
                {t("recently_onboarded_merchants", "Recently Onboarded Merchants")}
              </MDTypography>
            </MDBox>
            {stats?.recentMerchants?.length > 0 ? (
              <DataTable
                table={{ columns: recentMerchantColumns, rows: stats.recentMerchants }}
                isSorted={false}
                entriesPerPage={false}
                showTotalEntries={false}
                noEndBorder
              />
            ) : (
              <MDBox p={3} pt={1}>
                <MDTypography variant="body2" color="text">
                  No merchants onboarded yet.
                </MDTypography>
              </MDBox>
            )}
          </Card>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default SuperUserDashboard;
